import Splide from '@splidejs/splide';
import { arrowPath } from '../components/carousel';
import { onYouTubeIframeAPIReady, YouTubeTPlayerMethods } from './videoYouTubeIframeAPI';
import resource from './resource';

const create = {
  carousel: (images, videoUrl, productContainer) => {
    const isQuickViewShown = $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
    if ((images === undefined || images === null) && !videoUrl) {
      return false;
    }

    const $slider = productContainer.find('.primary-slider');
    const $thumbnail = productContainer.find('#thumbnail');
    let $html = {};

    if (images.large.length > 0) {
      $slider.each((index, item) => {
        $(item).find('.splide__list').empty();
      });
    }

    if (images.small.length > 0) {
      $thumbnail.find('.splide__list').empty();
    }

    $(images.large).each((index, item) => {
      $html = $(
        '<li class="splide__slide"><img src="' +
          item.url +
          '" class="d-block img-fluid w-100" alt="' +
          item.alt +
          '" title="' +
          item.title +
          '" itemprop="image" /></li>'
      );

      $html.appendTo($slider.find('.splide__list'));
    });

    $(images.small).each((index, item) => {
      const $html = $(
        '<li class="splide__slide"><img src="' +
          item.url +
          '" class="d-block img-fluid w-100" alt="' +
          item.alt +
          '" title="' +
          item.title +
          '" itemprop="image" /></li>'
      );

      $html.appendTo($thumbnail.find('.splide__list'));
    });

    if (videoUrl) {
      const $htmlVideoZoom = $(`
        <li class="splide__slide video" data-video-url="${videoUrl}">
          <iframe width="100%" height="220" src="${videoUrl}" title="YouTube video player" frameborder="0" allowfullscreen></iframe>
          <div class="video-cover"></div>
        </li>
      `);

      const $htmlVideoThumb = $(`
        <li class="splide__slide">
          <div class="video-cover thumb" data-video-url="${videoUrl}">
            <button class="play-button thumb">
              <span class="sr-only">Play</span>
              <div class="triangle" aria-hidden="true"></div>
            </button>
          </div>
        </li>
      `);

      $htmlVideoZoom.appendTo($slider.find('.splide__list'));
      $htmlVideoThumb.appendTo($thumbnail.find('.splide__list'));
      create.setVideoModal(videoUrl);
      create.setThumbVideoCover();
    }
    if (!isQuickViewShown) {
      create.carouselImage('#slider', '#thumbnail');
      create.carouselImageSingle('#slider-single');
    } // else {
    //   create.carouselImage('#quickViewModal #slider', '#quickViewModal #thumbnail');
    // }
  },
  carouselImage: (primarySlider, thumbnailSlider) => {
    if ((primarySlider && thumbnailSlider === null) || undefined) {
      return false;
    }

    const $thumbnailSlides = $(thumbnailSlider).find('.splide__slide');

    // if only one slide, initialize only primary slider and hide splide thumbnail
    if ($thumbnailSlides.length <= 1) {
      const slider = new Splide(primarySlider, {
        type: 'fade',
        pagination: false,
        arrows: false,
        cover: true
      });

      slider.mount();

      // hide thumbnail slider
      $(thumbnailSlider).addClass('d-none');

      // remove styles injected by Splide.js
      $(thumbnailSlider).find('.splide__slide').removeAttr('style');
      $(thumbnailSlider).find('.splide__track').removeAttr('style');
      $(thumbnailSlider).find('.splide__list').removeAttr('style');

      return;
    }

    const slider = new Splide(primarySlider, {
      type: 'fade',
      pagination: false,
      arrows: false,
      cover: true,
      breakpoints: {
        1024: {
          isNavigation: true,
          arrows: true
        }
      }
    });

    $(thumbnailSlider).removeClass('d-none');

    const thumbnail = new Splide(thumbnailSlider, {
      fixedWidth: 70,
      fixedHeight: 70,
      gap: 14,
      pagination: false,
      cover: true,
      isNavigation: true,
      arrowPath: arrowPath,
      i18n: {
        prev: resource.msg('button.previous', 'common'),
        next: resource.msg('button.next', 'common')
      }
    }).mount();

    slider.sync(thumbnail).mount();
  },
  carouselImageSingle: (primarySliderSingle) => {
    if (primarySliderSingle === null || primarySliderSingle === undefined || $(primarySliderSingle).length === 0) {
      return false;
    }

    const slider = new Splide(primarySliderSingle, {
      type: 'fade',
      pagination: false,
      arrows: true,
      i18n: {
        prev: resource.msg('button.previous', 'common'),
        next: resource.msg('button.next', 'common')
      },
      cover: true,
      arrowPath: arrowPath
    });

    slider.on('active', function (Slide) {
      if ($(Slide.slide).hasClass('video')) {
        $(primarySliderSingle).find('.discount').hide();
        $(primarySliderSingle).find('.wishlist-product-page-button').hide();
      } else {
        $(primarySliderSingle).find('.discount').show();
        $(primarySliderSingle).find('.wishlist-product-page-button').show();
      }
    });

    slider.mount();
  },
  watermark: (imageURL, product, watermarkType) => {
    let watermarkClass;
    if (!imageURL) {
      return false;
    }

    if (watermarkType) {
      watermarkClass = watermarkType.replace(/\s+/g, '-') + '__watermark';
    }

    $('.primary-slider')
      .find('.splide__slide:not(.video)')
      .each((index, item) => {
        const $watermark = $(
          `<img src="${imageURL.toString()}" class="product-image-watermark dmo-watermark ${watermarkClass}" alt="${
            product.name + ' - Watermark'
          }" />`
        );
        $watermark.appendTo($(item));
      });
  },
  zoom: (primarySlider) => {
    if (primarySlider === null || undefined) {
      return false;
    }
    $('[data-zoom]', primarySlider).on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const $this = $(e.currentTarget);
      const zoomModal = $('#zoom-modal');
      const zoomUrl = $this.data('zoom');
      const image = $('<img/>').attr('src', zoomUrl).addClass('d-block img-fluid w-100');
      zoomModal.find('.modal-body').empty();
      zoomModal.find('.modal-body').append(image);
      zoomModal.modal('show');
    });
  },

  createVideoModal: () => {
    if (!$('#pdp-video-modal').length) {
      const videoModalHtml = $(`
      <div class="modal fade" id="pdp-video-modal" role="dialog" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-dismiss="modal">
                <span class="sr-only">Chiudi</span>
                <svg width="16px" height="16px" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.3230925,15.6769025 C0.7538825,16.1077025 1.4541925,16.1077025 1.8849825,15.6769025 L8,9.5619025 L14.1150025,15.6769025 C14.5458025,16.1077025 15.2461025,16.1077025 15.6769025,15.6769025 C16.1077025,15.2461025 16.1077025,14.5458025 15.6769025,14.1150025 L9.5619025,8 L15.6769025,1.8849825 C16.1077025,1.4541925 16.1077025,0.7538825 15.6769025,0.3230925 C15.2461025,-0.1076975 14.5458025,-0.1076975 14.1150025,0.3230925 L8,6.4381025 L1.8849825,0.3230925 C1.4541925,-0.1076975 0.7538825,-0.1076975 0.3230925,0.3230925 C-0.1076975,0.7538825 -0.1076975,1.4541925 0.3230925,1.8849825 L6.4381025,8 L0.3230925,14.1150025 C-0.1076975,14.5458025 -0.1076975,15.2461025 0.3230925,15.6769025 Z"/>
                </svg>
              </button>
            </div>
            <div class="modal-body">
              <iframe width="100%" height="390" src="" frameborder="0" allow="autoplay;" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    `);
      videoModalHtml.appendTo($('body'));
    }
  },

  setVideoModal: (videoUrl, slider) => {
    const $slider = $('.primary-slider') || slider;
    const videoSlides = $slider.find('.splide__slide.video');
    if (!videoSlides || !videoSlides.length) return;

    create.createVideoModal();

    for (let index = 0; index < videoSlides.length; index++) {
      const slide = $(videoSlides[index]);

      const videoCover = slide.find('.video-cover');
      if (!videoUrl) {
        videoUrl = slide.data('video-url');
      }

      if (!videoUrl) continue;

      videoCover.on('click', () => {
        const videoModal = $('#pdp-video-modal');
        const videoIframe = videoModal.find('iframe');
        videoIframe.attr('src', `${videoUrl}&rel=0&playsinline=0&autoplay=1&showinfo=0&autohide=1&controls=1&modestbranding=1`);
        videoModal.modal('show');

        videoModal.on('hidden.bs.modal', () => {
          videoIframe.attr('src', '');
        });
      });
    }
  },

  initVideoCarousel: () => {
    const slider = document.getElementById('videoSlider');
    const sliderID = '#videoSlider';
    if (!slider || slider.length < 0) return;
    const slides = slider.getElementsByClassName('splide__slide');

    if (slides.length > 0) {
      $(sliderID)
        .removeClass('d-none')
        .removeClass('is-active')
        .addClass(slides.length === 1 ? 'single-item' : '');
    }

    onYouTubeIframeAPIReady(slides);

    if (slides.length > 1) {
      const carousel = new Splide(sliderID, {
        perPage: 2,
        rewind: true,
        gap: 14,
        pagination: true,
        arrows: false,
        breakpoints: {
          1024: {
            perPage: 1
          }
        }
      });

      carousel.on('active', function (Slide) {
        const currentSlideIndex = Slide.index;

        if (window.videoPlayerOZReady && window.videoPlayerOZ && window.videoPlayerOZ.length) {
          const playerTotal = window.videoPlayerOZ.length;

          for (let index = 0; index < playerTotal; index++) {
            if (index !== currentSlideIndex) {
              window.videoPlayerOZ[index].stopVideo();
            }
          }
        }
      });

      carousel.mount();
    }
  },

  updateVideoCarousel: (videoURLs) => {
    const $slider = $('#videoSlider');
    if (!$slider.length) return;

    if (videoURLs && videoURLs.length) {
      let $htmlVideoSlide = {};

      $slider.each((index, item) => {
        $(item).find('.splide__list').empty();
      });

      $(videoURLs).each((index, videoUrl) => {
        $htmlVideoSlide = $(`
          <li class="splide__slide video stop" id="videoContainer_${index}" data-video-url="${videoUrl}">
            <div class="video"></div>
            <div class="video-cover">
              <button class="play-button">
                <span class="sr-only">Play</span>
                <div class="triangle" aria-hidden="true"></div>
              </button>
            </div>
          </li>
        `);

        $htmlVideoSlide.appendTo($slider.find('.splide__list'));
      });

      $slider.find('.splide__pagination').remove();

      create.initVideoCarousel();
    } else {
      $slider.addClass('d-none');
    }
  },

  setThumbVideoCover: () => {
    const thumbSlider = document.getElementById('thumbnail');
    const slides = thumbSlider.getElementsByClassName('splide__slide');
    const slideTotal = slides.length;

    for (let index = 0; index < slideTotal; index++) {
      const slide = slides[index];
      const videoCoverContainer = slide.getElementsByClassName('video-cover')[0];

      if (videoCoverContainer) {
        const videoUrl = videoCoverContainer.getAttribute('data-video-url');
        if (videoUrl) {
          const coverUrl = create.getVideoCoverUrl(videoUrl);

          if (coverUrl) {
            const imgElement = document.createElement('img');
            imgElement.src = coverUrl;
            videoCoverContainer.append(imgElement);
          }
        }
      }
    }
  },

  getVideoCoverUrl: (videoUrl) => {
    if (!videoUrl) return null;

    const videoID = YouTubeTPlayerMethods.getVideoID(videoUrl);

    if (videoID) {
      return `${YouTubeTPlayerMethods.videoCoverSrc}${videoID}/${YouTubeTPlayerMethods.videoCoverImageIndex}`;
    } else {
      return null;
    }
  }
};

export default create;
